import React from 'react';
const TrashCanDark = () =>(
    <svg width="13" style={{transform:"scale(1.1)"}} height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.73333 5.50394C3.99107 5.50394 4.2 5.71287 4.2 5.97061V11.5706C4.2 11.8283 3.99107 12.0373 3.73333 12.0373C3.4756 12.0373 3.26667 11.8283 3.26667 11.5706V5.97061C3.26667 5.71287 3.4756 5.50394 3.73333 5.50394Z"
            fill="#333333"/>
        <path
            d="M6.06667 5.50394C6.3244 5.50394 6.53333 5.71287 6.53333 5.97061V11.5706C6.53333 11.8283 6.3244 12.0373 6.06667 12.0373C5.80893 12.0373 5.6 11.8283 5.6 11.5706V5.97061C5.6 5.71287 5.80893 5.50394 6.06667 5.50394Z"
            fill="#333333"/>
        <path
            d="M8.86667 5.97061C8.86667 5.71287 8.65773 5.50394 8.4 5.50394C8.14227 5.50394 7.93333 5.71287 7.93333 5.97061V11.5706C7.93333 11.8283 8.14227 12.0373 8.4 12.0373C8.65773 12.0373 8.86667 11.8283 8.86667 11.5706V5.97061Z"
            fill="#333333"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.1333 3.17061C12.1333 3.68607 11.7155 4.10394 11.2 4.10394H10.7333V12.5039C10.7333 13.5349 9.8976 14.3706 8.86667 14.3706H3.26667C2.23574 14.3706 1.4 13.5349 1.4 12.5039V4.10394H0.933333C0.417868 4.10394 0 3.68607 0 3.17061V2.23727C0 1.72181 0.417868 1.30394 0.933333 1.30394H4.2C4.2 0.788473 4.61787 0.370605 5.13333 0.370605H7C7.51547 0.370605 7.93333 0.788473 7.93333 1.30394H11.2C11.7155 1.30394 12.1333 1.72181 12.1333 2.23727V3.17061ZM2.4435 4.10394L2.33333 4.15902V12.5039C2.33333 13.0194 2.7512 13.4373 3.26667 13.4373H8.86667C9.38213 13.4373 9.8 13.0194 9.8 12.5039V4.15902L9.68983 4.10394H2.4435ZM0.933333 3.17061V2.23727H11.2V3.17061H0.933333Z"
              fill="#333333"/>
    </svg>

)

export default TrashCanDark;

